export enum GenderType {
  Unspecified = "Unspecified",
  Male = "Male",
  Female = "Female",
  NonBinary = "NonBinary",
  Other = "Other",
}

export function dummyHttp<T = any>(response: T): Promise<T> {
  return Promise.resolve(response);
}
